// Module
var code = "<aside data-ref=content></aside>";
// Exports
export default code;